import { useQuery } from '@tanstack/react-query'
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCryptoCurrencies } from 'services/CurrencyService'

export const useCryptoCurrenciesQuery = () => {
  const { currentAccount } = useAccountsContext()
  const accRef = currentAccount?.reference

  return useQuery({
    queryKey: reactQueryKeys.cryptoCurrencies(accRef),
    queryFn: () => getCryptoCurrencies(accRef),
    refetchOnReconnect: false,
  })
}
